import { render } from "./PageStudentDetails.vue?vue&type=template&id=a0048b80"
import script from "./PageStudentDetails.vue?vue&type=script&lang=js"
export * from "./PageStudentDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/shenshenmac/codes/fan_mei/fanmei_v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__